// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Components
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FooterComponent } from './footer/footer.component';
import { ListnavComponent } from './listnav/listnav.component';
import { ModalComponent } from './modal/modal.component';
import { ModalGridComponent } from './modal/grid/modal-grid.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NoticeComponent } from './notice/notice.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TextFormatComponent } from './text-format/text-format.component';
import { GeneralModalComponent } from './general-modal/general-modal.component';
import { RestrictedContentComponent } from './restricted-content/restricted-content.component';
import { RestrictedLockComponent } from './restricted-lock/restricted-lock.component';
import { FlatDesignModule } from '@medsurf/flat-designs';
import { ScrollTopPipe } from '@medsurf/flat-pipes';

/**
 * Medsurf Viewer Common Module
 */
@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    RouterModule,
    // Bootstrap
    NgbModule,
    // Translate
    TranslateModule.forChild(),
    FlatDesignModule,
  ],
  declarations: [
    // Components
    CookieConsentComponent,
    FeedbackComponent,
    FooterComponent,
    ListnavComponent,
    ModalComponent,
    ModalGridComponent,
    NavbarComponent,
    NoticeComponent,
    SidebarComponent,
    TextFormatComponent,
    GeneralModalComponent,
    RestrictedContentComponent,
    RestrictedLockComponent,
    // Pipes
    ScrollTopPipe
  ],
  exports: [
    // Components
    CookieConsentComponent,
    FeedbackComponent,
    FooterComponent,
    ListnavComponent,
    ModalComponent,
    NavbarComponent,
    NoticeComponent,
    SidebarComponent,
    TextFormatComponent,
    GeneralModalComponent,
    RestrictedContentComponent,
    RestrictedLockComponent,
    // Pipes
    ScrollTopPipe
  ]
})
export class MedsurfViewerCommonModule {
}
